import { render, staticRenderFns } from "./RecurringRemarkListView.vue?vue&type=template&id=1a75e321"
import script from "./RecurringRemarkListView.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a75e321')) {
      api.createRecord('1a75e321', component.options)
    } else {
      api.reload('1a75e321', component.options)
    }
    module.hot.accept("./RecurringRemarkListView.vue?vue&type=template&id=1a75e321", function () {
      api.rerender('1a75e321', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recurringremarks/RecurringRemarkListView.vue"
export default component.exports